module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"it":{"i_accept_nutritionist_privacy_policy":"Informativa Privacy Nutrizionista","i_accept_nutriyou_privacy_policy":"Privacy Servizio Nutriyou"}}')
  delete Component.options._Ctor
}
